export default {"src":"/_next/static/media/mind.7689ba9c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};